(() => {
  if (customElements.get('vitablue-cart-discount')) return;
  const root = window.Shopify?.routes?.root || '/';
  let busy = false;
  const key = 'vitablueDiscountOpen';
  const codes = (cart) => {
    const titles = Array.isArray(cart.discount_codes) ?
      cart.discount_codes.filter((item) => item.applicable).map((item) => item.code) :
      [...(cart.cart_level_discount_applications || []), ...(cart.items || []).flatMap((item) =>
        (item.line_level_discount_allocations || []).map((allocation) => allocation.discount_application))]
        .filter((item) => item.type === 'discount_code').map((item) => item.title);
    return [...new Map(titles.filter(Boolean).map((code) => [code.toUpperCase(), code])).values()];
  };
  const read = async () => {
    const response = await fetch(`${root}cart.js`, { cache: 'no-store', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Cart unavailable');
    return response.json();
  };
  const current = () => document.querySelector('#CartDrawer vitablue-cart-discount');
  customElements.define('vitablue-cart-discount', class extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('.vb-discount__toggle');
      this.panel = this.querySelector('.vb-discount__panel');
      this.form = this.querySelector('form');
      this.input = this.querySelector('input');
      try { this.setOpen(sessionStorage.getItem(key) === 'true'); } catch { this.setOpen(false); }
      try { this.paintCodes(JSON.parse(this.querySelector('[data-discount-cart]').textContent)); } catch { this.paintCodes({}); }
      this.toggle.addEventListener('click', () => {
        const open = this.toggle.getAttribute('aria-expanded') !== 'true';
        this.setOpen(open);
        try { sessionStorage.setItem(key, String(open)); } catch {}
        if (open) this.input.focus();
      });
      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        const code = this.input.value.trim();
        if (!code) return this.error(this.dataset.empty);
        this.update(code, false);
      });
      this.lock(busy);
    }
    setOpen(open) {
      this.toggle.setAttribute('aria-expanded', String(open));
      this.panel.inert = !open;
      this.classList.toggle('is-open', open);
    }
    lock(locked) {
      this.setAttribute('aria-busy', String(locked));
      this.querySelectorAll('button:not(.vb-discount__toggle), input').forEach((node) => { node.disabled = locked; });
    }
    error(message) {
      const node = this.querySelector('[data-discount-error]');
      node.textContent = message;
      node.hidden = false;
    }
    paintCodes(cart) {
      const holder = this.querySelector('[data-discount-codes]');
      holder.replaceChildren(...codes(cart).map((code) => {
        const chip = document.createElement('span');
        chip.className = 'vb-discount__chip';
        const text = document.createElement('span');
        text.textContent = code;
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.textContent = '×';
        remove.setAttribute('aria-label', this.dataset.remove.replace('[code]', code));
        remove.addEventListener('click', () => this.update(code, true));
        chip.append(text, remove);
        return chip;
      }));
    }
    async update(code, remove) {
      if (busy) return;
      busy = true;
      this.lock(true);
      this.querySelector('[data-discount-error]').hidden = true;
      const messages = { invalid: this.dataset.invalid, error: this.dataset.error };
      try {
        const before = await read();
        const existing = codes(before);
        const wanted = remove ? existing.filter((item) => item.toUpperCase() !== code.toUpperCase()) :
          [...new Map([...existing, code].map((item) => [item.toUpperCase(), item])).values()];
        if (JSON.stringify(wanted) === JSON.stringify(existing)) {
          this.paintCodes(before);
          return;
        }
        const drawer = document.querySelector('cart-drawer');
        const response = await fetch(`${root}cart/update.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: wanted.join(','), sections: drawer.getSectionsToRender().map((section) => section.id), sections_url: location.pathname }),
        });
        if (!response.ok) throw new Error('Discount request failed');
        const cart = await response.json();
        const applied = codes(cart).some((item) => item.toUpperCase() === code.toUpperCase());
        if (!cart.sections || drawer.getSectionsToRender().some((section) => !cart.sections[section.id])) {
          const url = new URL(root, location.origin);
          url.searchParams.set('sections', drawer.getSectionsToRender().map((section) => section.id).join(','));
          const sections = await fetch(url, { headers: { Accept: 'application/json' }, cache: 'no-store' });
          if (!sections.ok) throw new Error('Section request failed');
          cart.sections = await sections.json();
          if (drawer.getSectionsToRender().some((section) => !cart.sections[section.id])) throw new Error('Missing cart section');
        }
        drawer.renderContents(cart);
        current()?.paintCodes(cart);
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: cart });
        if (remove ? applied : !applied) current()?.error(messages.invalid);
        else if (!remove) {
          current().input.value = '';
          current().setOpen(false);
          try { sessionStorage.setItem(key, 'false'); } catch {}
        }
      } catch {
        current()?.error(messages.error);
      } finally {
        busy = false;
        current()?.lock(false);
      }
    }
  });
})();
